import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, LinkData } from '../types'
import { CmsConverterService, defaultFSCatalog, defaultLinkData } from '../../services/cms-converter/cms-converter.service'
import { LocationsMapRegionData } from './locations-map-region/locations-map-region.component.converter'

@Injectable({ providedIn: 'root' })
export class LocationsMapConverter extends CmsConverterService<LocationsMapData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      link: formData.st_link ?? defaultLinkData,
      regions: formData?.st_regions ?? defaultFSCatalog,
    }
  }
}

export const LOCATIONS_MAP_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, LocationsMapData>>('LocationsMapConverter')

export interface LocationsMapData extends ConvertedComponentData {
  link: LinkData;
  regions: FsCatalog<LocationsMapRegionData>;
}
